import { ThunkAction } from 'redux-thunk';
import { downloadComparisonResult } from '../services/contractApi';

/**
 * 比較結果-TSVダウンロード用モジュール
 */
export interface ComparisonDownloadState {
  comparisonDownload: Promise<Blob> | null;
  comparisonDownloadedSuccessMessages: string[];
  comparisonDownloadedErrorMessages: string[];
  status: number;
}

const initialState: ComparisonDownloadState = {
  comparisonDownload: null,
  comparisonDownloadedSuccessMessages: [],
  comparisonDownloadedErrorMessages: [],
  status: 0,
};

const REQUEST_COMPARISON_DOWNLOAD = 'REQUEST_COMPARISON_DOWNLOAD';
type REQUEST_COMPARISON_DOWNLOAD = typeof REQUEST_COMPARISON_DOWNLOAD;

const RECEIVE_COMPARISON_DOWNLOAD = 'RECEIVE_COMPARISON_DOWNLOAD';
type RECEIVE_COMPARISON_DOWNLOAD = typeof RECEIVE_COMPARISON_DOWNLOAD;

const FAIL_COMPARISON_DOWNLOAD = 'FAIL_COMPARISON_DOWNLOAD';
type FAIL_COMPARISON_DOWNLOAD = typeof FAIL_COMPARISON_DOWNLOAD;

const CLEAR_COMPARISON_DOWNLOAD = 'CLEAR_COMPARISON_DOWNLOAD';
type CLEAR_COMPARISON_DOWNLOAD = typeof CLEAR_COMPARISON_DOWNLOAD;

const CLEAR_COMPARISON_DOWNLOADED_MESSAGES = 'CLEAR_COMPARISON_DOWNLOADED_MESSAGES';
type CLEAR_COMPARISON_DOWNLOADED_MESSAGES = typeof CLEAR_COMPARISON_DOWNLOADED_MESSAGES;

interface RequestComparisonDownload {
  type: REQUEST_COMPARISON_DOWNLOAD;
}

interface ReceiveComparisonDownload {
  type: RECEIVE_COMPARISON_DOWNLOAD;
  comparisonDownload: Promise<Blob>;
}

interface FailComparisonDownload {
  type: FAIL_COMPARISON_DOWNLOAD;
  comparisonDownloadedErrorMessages: string[];
  status: number;
}

interface ClearComparisonDownload {
  type: CLEAR_COMPARISON_DOWNLOAD;
}

interface ClearComparisonDownloadedMessages {
  type: CLEAR_COMPARISON_DOWNLOADED_MESSAGES;
}

export type DownloadComparisonAction = RequestComparisonDownload | ReceiveComparisonDownload |
  FailComparisonDownload | ClearComparisonDownload | ClearComparisonDownloadedMessages;

type DownloadComparisonDocuments =
  ThunkAction<void, ComparisonDownloadState, undefined, DownloadComparisonAction>;

export function requestComparisonDownload(): RequestComparisonDownload {
  return {
    type: REQUEST_COMPARISON_DOWNLOAD,
  };
}

export function receiveComparisonDownload(comparisonDownload: Promise<Blob>)
  : ReceiveComparisonDownload {
  return {
    comparisonDownload,
    type: RECEIVE_COMPARISON_DOWNLOAD,
  };
}

export function failComparisonDownload(comparisonDownloadedErrorMessages: string[], status: number)
  : FailComparisonDownload {
  return {
    comparisonDownloadedErrorMessages,
    status,
    type: FAIL_COMPARISON_DOWNLOAD,
  };
}

export function clearComparisonDownload(): ClearComparisonDownload {
  return {
    type: CLEAR_COMPARISON_DOWNLOAD,
  };
}

export function clearComparisonDownloadedMessages(): ClearComparisonDownloadedMessages {
  return {
    type: CLEAR_COMPARISON_DOWNLOADED_MESSAGES,
  };
}

export function downloadComparisonDocuments(fileIds: number[], fileTypes: string[])
  : DownloadComparisonDocuments {
  return (dispatch) => {
    dispatch(requestComparisonDownload());
    // ダウンロードAPI呼び出し
    return downloadComparisonResult(fileIds, fileTypes).then((res) => {
      if (res.status === 200 && res) {
        dispatch(receiveComparisonDownload(res.blob()));
      } else {
        res.json().catch((error) => {
          dispatch(failComparisonDownload(error, res.status));
        });
      }
    }).catch((err) => {
      dispatch(failComparisonDownload([String(err)], 500));
    });
  };
}

export default function reducer(
  state: ComparisonDownloadState | undefined,
  action: DownloadComparisonAction,
): ComparisonDownloadState {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_COMPARISON_DOWNLOAD: {
      return state;
    }
    case RECEIVE_COMPARISON_DOWNLOAD: {
      const { comparisonDownload } = action;
      return { comparisonDownload,
        comparisonDownloadedSuccessMessages: [], comparisonDownloadedErrorMessages: [], status: 0};
    }
    case FAIL_COMPARISON_DOWNLOAD: {
      const { comparisonDownloadedErrorMessages, status } = action;
      return { ...state, status, comparisonDownloadedErrorMessages, comparisonDownload: null };
    }
    case CLEAR_COMPARISON_DOWNLOAD: {
      return initialState;
    }
    case CLEAR_COMPARISON_DOWNLOADED_MESSAGES: {
      return {
        ...state,
        comparisonDownloadedSuccessMessages: [],
        comparisonDownloadedErrorMessages: [],
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/comparisonTsv.ts